module.exports = __webpack_public_path__ + "img/icon_img2.d0346a78.png";